import { Feature } from "ol";
import { Point } from "ol/geom";
import { fromLonLat } from "ol/proj";
import Icon from "ol/style/Icon";
import Style from "ol/style/Style";
import BaseFeature from "../base.feature";
import IFlagDataReport from "@/models/reports/flag-data.report";

export default class FlagFeature extends BaseFeature {

    flag: IFlagDataReport

    constructor(flag: IFlagDataReport) {
        super()
        this.flag = flag
    }

    getFeature() {
        return new Feature({
            geometry: new Point(fromLonLat([this.flag.longitude, this.flag.latitude])), //recoge las coordenadas de ubicacion
            type: 'flag',
            data: this.flag
        })
    }

    getStyle(): Style {
        return new Style({
            image: new Icon(({
                anchor: [0.5, 1],
                scale: 0.55,
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                crossOrigin: 'anonymous',
                src: require(`@/assets/img/pointers/${this.flag.icon}.png`)
            })),

        })
    }

    isValid(): boolean {
        return true
    }

}